import { useState } from 'react';
import {
  IEditForm,
  CasEditForm,
  CasRHFSwitch,
  CasRHFTextField,
  CasStackRow,
  CasRHFPercentField,
  CasRHFSelect,
} from 'src/compass/shared/components';

import {
  CasAsOfContainer,
  EntityInfoCMESources,
  useDefaultAsOfValues,
} from 'src/compass/application/commissions';

import { CMESourceSchema } from './CMESourceSchema';
import SourceAdjustAfterFields from './SourceAdjustAfterFields';

const SOURCE_TYPE_OPTIONS = [
  { id: 'Handoff', name: 'Handoff' },
  { id: 'BusDev', name: 'Business Development' },
];

export default function CMESourceForm({ row, onSaved }: IEditForm) {
  const { id } = row || {};

  const [asofReadonly, setAsofReadonly] = useState(false);

  const defaultValues = useDefaultAsOfValues(row, { isActive: true });

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity={EntityInfoCMESources.entity}
      schema={CMESourceSchema}
    >
      <CasStackRow>
        <CasRHFTextField name="description" label="Description" />
        <CasRHFSwitch name="isActive" label="Active" />
      </CasStackRow>
      <CasRHFSelect options={SOURCE_TYPE_OPTIONS} name="sourceType" label="Type" disabled={!!id} />
      <CasRHFTextField name="lrpglAccountInfo" label="LRP G/L Account" />
      <CasAsOfContainer
        entityTitle="CME Source AsOf"
        entityId={id}
        deleteChildEntity="Cme/AccountSources/AsOf"
        initialAsOfList={row?.asOfs}
        initialAsOf={defaultValues.asOf}
        readOnly={asofReadonly}
        setReadOnly={setAsofReadonly}
      >
        <CasStackRow>
          <CasRHFPercentField
            name="asOf.cmeRatePercent"
            label="CME Rate"
            disabled={asofReadonly}
          />
        </CasStackRow>
        <CasStackRow>
          <CasRHFPercentField
            name="asOf.lrpRatePercent"
            label="LRP Rate"
            disabled={asofReadonly}
          />
        </CasStackRow>
        <SourceAdjustAfterFields asofReadonly={asofReadonly} />
      </CasAsOfContainer>
    </CasEditForm>
  );
}
